import React from "react";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";
import "./ReceiveTransferForm.scss";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

// One row per pallet line: what was expected, and a small input for what
// arrived (starting at the expected quantity).
function renderReceivedLines(fieldProps) {
  const {fields, lines} = fieldProps;
  const expectedTotal = lines.reduce((sum, line) => sum + (line.get("quantity") || 0), 0);
  return (
    <table className="receiveTable">
      <thead>
        <tr>
          <th>Pallet</th>
          <th>SKU</th>
          <th className="number">Expected</th>
          <th className="number">Received</th>
        </tr>
      </thead>
      <tbody>
        {fields.map((member, index) => {
          const line = lines.get(index);
          return (
            <tr key={index}>
              <td className="pallet">{line.get("palletId")}</td>
              <td>{line.get("stockSku")}</td>
              <td className="number">{line.get("quantity")}</td>
              <td className="number">
                <Field
                  name={`${member}.receivedQuantity`}
                  type="number"
                  normalize={numerical}
                  component={TextInputField}
                  table={false}
                  />
              </td>
            </tr>
          )
        })}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={2}>Total</td>
          <td className="number">{expectedTotal}</td>
          <td />
        </tr>
      </tfoot>
    </table>
  )
}

class ReceiveTransferForm extends React.Component {

  render() {
    let {errors, handleSubmit, submit, lines, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Receive Transfer";
    return (
      <form onSubmit={handleSubmit} className="ReceiveTransferForm">
        <div className="fields">
          <p>Enter what arrived for each line. It starts at the expected quantity.</p>
          <FieldArray name="receivedLines" component={renderReceivedLines} props={{lines}} />
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ReceiveStockTransferForm"
})(ReceiveTransferForm);

export default ReduxForm;
